import { render, staticRenderFns } from "./patient.vue?vue&type=template&id=89e52d7c&scoped=true&"
import script from "./patient.vue?vue&type=script&lang=js&"
export * from "./patient.vue?vue&type=script&lang=js&"
import style0 from "./patient.vue?vue&type=style&index=0&id=89e52d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e52d7c",
  null
  
)

export default component.exports